import {
  isNikolaTeamMember,
  type User,
  type ValidateAuthenticatedUser,
} from "@assetwatch/auth";

export const MODALITY_ACCESS_DENIED_MESSAGE =
  "You do not have access to the Modality app.";

export type MotionAmplificationAccessFlags = {
  motionAmplificationEnabled: boolean;
};

function hasInternalRole(user: User | null): boolean {
  return isNikolaTeamMember(user);
}

export function canAccessModality(user: User | null): boolean {
  return hasInternalRole(user);
}

export function createModalityAccessValidator(
  validateProvisionedUser?: ValidateAuthenticatedUser,
): ValidateAuthenticatedUser {
  return async ({ session, user }) => {
    const provisionValidation = await validateProvisionedUser?.({
      session,
      user,
    });
    if (provisionValidation && !provisionValidation.ok) {
      return provisionValidation;
    }

    if (!canAccessModality(user)) {
      return { ok: false, message: MODALITY_ACCESS_DENIED_MESSAGE };
    }

    return { ok: true };
  };
}

export function canAccessMotionAmplification({
  flags,
  user,
}: {
  flags: MotionAmplificationAccessFlags;
  user: User | null;
}): boolean {
  return flags.motionAmplificationEnabled && canAccessModality(user);
}
